// Generated by scripts/sync-mc-labels.mjs from frontend/mc-source (GLOSSARY.md, DS-LABEL-EXCERPTS.md).
// Do not edit: change the vendored sources by a deliberate --refresh commit and regenerate.

export interface ForbiddenEntry {
  readonly text: string;
  readonly mode: "phrase" | "label" | "regex";
  readonly source: string;
  readonly pattern: string;
}

export const TERMS: readonly { readonly term: string; readonly section: number; readonly where: string }[] = [
  {
    "term": "Talent Acquisition Hiring Hub / Hiring Hub",
    "section": 1,
    "where": "Tejesh 12 Oct 06:34 (F-153); BRD §1.1"
  },
  {
    "term": "Hiring Hub principles",
    "section": 1,
    "where": "BRD §1.1"
  },
  {
    "term": "Current-state baseline",
    "section": 1,
    "where": "BRD front matter, Appendix A"
  },
  {
    "term": "Future state",
    "section": 1,
    "where": "BRD front matter, §2"
  },
  {
    "term": "Responsibility-based visibility",
    "section": 1,
    "where": "BRD §1.1, §4.5"
  },
  {
    "term": "Field-level security",
    "section": 1,
    "where": "BRD §1.1, §6"
  },
  {
    "term": "Candidate experience",
    "section": 1,
    "where": "BRD §1.1, §7"
  },
  {
    "term": "Operational assistant (AI)",
    "section": 1,
    "where": "Tejesh 13 Oct 17:11 (R7); Spec §2; BRD §11"
  },
  {
    "term": "Material change",
    "section": 1,
    "where": "Spec §2; BRD §1.1"
  },
  {
    "term": "CR (change request)",
    "section": 1,
    "where": "BRD §1, §12"
  },
  {
    "term": "Process Guide",
    "section": 1,
    "where": "BRD §14, Appendix A"
  },
  {
    "term": "Action Center",
    "section": 2,
    "where": "BRD §4.1, §3.6 (\"HM Action Center\"), §10.1; Spec Epic 9.1"
  },
  {
    "term": "Action Item",
    "section": 2,
    "where": "Spec §3, Epic 9.1; BRD §10.1"
  },
  {
    "term": "Priority",
    "section": 2,
    "where": "HM email (HM-2); BRD §4.1"
  },
  {
    "term": "Coordinator Workbench",
    "section": 2,
    "where": "BRD §4.2, §3.3, §3.8, §3.14; Spec Epic 5.1 (CR-084)"
  },
  {
    "term": "Candidate timeline",
    "section": 2,
    "where": "BRD §4.3, §10.2; CR-093"
  },
  {
    "term": "Requisition timeline",
    "section": 2,
    "where": "BRD §4.3; CR-094"
  },
  {
    "term": "Timeline event",
    "section": 2,
    "where": "Spec §3"
  },
  {
    "term": "Search Readiness",
    "section": 2,
    "where": "BRD §4.4; Spec Epic 9.1; CR-095"
  },
  {
    "term": "Readiness Snapshot",
    "section": 2,
    "where": "Spec §3"
  },
  {
    "term": "Req health / Requisition health",
    "section": 2,
    "where": "BRD §4.4; Spec Epic 9.1; CR-046"
  },
  {
    "term": "Health driver",
    "section": 2,
    "where": "BRD §4.4, §3.6, §3.7"
  },
  {
    "term": "Health Snapshot",
    "section": 2,
    "where": "Spec §3"
  },
  {
    "term": "Green / Yellow / Red",
    "section": 2,
    "where": "BRD §4.4"
  },
  {
    "term": "Responsibility-Based Dashboard",
    "section": 2,
    "where": "BRD §4.5; CR-040, CR-052"
  },
  {
    "term": "General dashboard",
    "section": 2,
    "where": "BRD §4.5"
  },
  {
    "term": "Persona dashboard",
    "section": 2,
    "where": "Spec Epic 9.2; CR-040"
  },
  {
    "term": "Executive dashboard",
    "section": 2,
    "where": "BRD §12"
  },
  {
    "term": "Multi-role dashboard",
    "section": 2,
    "where": "Spec Epic 9.2; BRD §15; CR-043"
  },
  {
    "term": "Security-trimmed widget",
    "section": 2,
    "where": "BRD §4.5; Spec Epic 9.1"
  },
  {
    "term": "Deep link",
    "section": 2,
    "where": "BRD §4.1, §3.6"
  },
  {
    "term": "Dashboard alert",
    "section": 2,
    "where": "BRD §3.7, §3.11"
  },
  {
    "term": "Disposition worklist",
    "section": 2,
    "where": "BRD §3.21"
  },
  {
    "term": "Debrief room",
    "section": 2,
    "where": "BRD §3.17"
  },
  {
    "term": "Attendance roll",
    "section": 2,
    "where": "BRD §3.17"
  },
  {
    "term": "Summary Sheet",
    "section": 2,
    "where": "BRD §2 step 16, §3.16"
  },
  {
    "term": "Candidate summary",
    "section": 2,
    "where": "BRD §3.16"
  },
  {
    "term": "TA Admin configuration console",
    "section": 2,
    "where": "BRD §8, §12; Spec Epic 9.3"
  },
  {
    "term": "Request Review screen",
    "section": 2,
    "where": "BRD §3.1"
  },
  {
    "term": "Intake & Panel scheduling screen",
    "section": 2,
    "where": "BRD §3.3"
  },
  {
    "term": "Assign/reassign Recruiter (page)",
    "section": 2,
    "where": "BRD §13; DC-232"
  },
  {
    "term": "Intake Part 2 screen",
    "section": 2,
    "where": "BRD §3.4"
  },
  {
    "term": "Interview-plan editor",
    "section": 2,
    "where": "BRD §3.4"
  },
  {
    "term": "Posting-strategy editor",
    "section": 2,
    "where": "BRD §3.4, §3.2"
  },
  {
    "term": "Coverage validator",
    "section": 2,
    "where": "BRD §3.4, §3.13; Spec Epic 4.2"
  },
  {
    "term": "Candidates screen",
    "section": 2,
    "where": "BRD §3.5"
  },
  {
    "term": "Candidate profile",
    "section": 2,
    "where": "BRD §3.5, §3.8, §10.2"
  },
  {
    "term": "Overview",
    "section": 2,
    "where": "his inspiration image; Email (Packet Builder 2.0)"
  },
  {
    "term": "HM resume-review screen",
    "section": 2,
    "where": "BRD §3.7"
  },
  {
    "term": "Recruiter Screen round / Round page",
    "section": 2,
    "where": "BRD §3.8, §3.10"
  },
  {
    "term": "HM packet/scorecard screen",
    "section": 2,
    "where": "BRD §3.11"
  },
  {
    "term": "Assessment section",
    "section": 2,
    "where": "BRD §3.12"
  },
  {
    "term": "Kickoff & Packets screen",
    "section": 2,
    "where": "BRD §3.13"
  },
  {
    "term": "Packet builder",
    "section": 2,
    "where": "BRD §3.13; Email \"Interview Packet Builder\""
  },
  {
    "term": "Candidates > Schedule rounds",
    "section": 2,
    "where": "BRD §3.14"
  },
  {
    "term": "Interviewer packet/scorecard",
    "section": 2,
    "where": "BRD §3.15, §3.13"
  },
  {
    "term": "Offer > Reference Check screen",
    "section": 2,
    "where": "BRD §3.18"
  },
  {
    "term": "Offer > Compensation screen",
    "section": 2,
    "where": "BRD §3.19"
  },
  {
    "term": "Offer screen",
    "section": 2,
    "where": "BRD §3.20"
  },
  {
    "term": "Compensation queue",
    "section": 2,
    "where": "BRD §3.2"
  },
  {
    "term": "Coordinator scheduling queue",
    "section": 2,
    "where": "BRD §3.9"
  },
  {
    "term": "Saved view",
    "section": 2,
    "where": "Spec Epic 9.2; BRD §7.2"
  },
  {
    "term": "Export",
    "section": 2,
    "where": "Spec Epic 9.2; BRD §7.2"
  },
  {
    "term": "Drill-down",
    "section": 2,
    "where": "Spec Epic 9.2; BRD §7.2; CR-051"
  },
  {
    "term": "Recruiter Copilot",
    "section": 2,
    "where": "BRD §11; Spec Epic 10; Tejesh 13 Oct 17:11 (R7)"
  },
  {
    "term": "HM / Hiring Manager",
    "section": 3,
    "where": "BRD §3.1, §3.7, §4.5, §13"
  },
  {
    "term": "Recruiter",
    "section": 3,
    "where": "BRD §3.5, §3.8, §3.13, §3.17, §3.19, §3.21, §13"
  },
  {
    "term": "Coordinator",
    "section": 3,
    "where": "BRD §3.2, §3.3, §3.21, §14, §13"
  },
  {
    "term": "HRBP / HR Business Partner",
    "section": 3,
    "where": "BRD §3.1, §3.4, §3.17, §8, §13"
  },
  {
    "term": "Compensation / Comp",
    "section": 3,
    "where": "BRD §3.2, §6, §13"
  },
  {
    "term": "Interviewer",
    "section": 3,
    "where": "BRD §3.15, §4.5, §3.8, §13"
  },
  {
    "term": "TA Manager / TA Mgr",
    "section": 3,
    "where": "BRD §3.2, §8, §13"
  },
  {
    "term": "Admin",
    "section": 3,
    "where": "BRD §3.2, §8, §3.21, §13"
  },
  {
    "term": "Engineering / System Admin",
    "section": 3,
    "where": "BRD §8; Spec Epic 9.3"
  },
  {
    "term": "Total Rewards",
    "section": 3,
    "where": "BRD §3.19"
  },
  {
    "term": "Organizational leader",
    "section": 3,
    "where": "BRD §3.19; Spec Epic 7.2"
  },
  {
    "term": "TA leadership",
    "section": 3,
    "where": "BRD §3.6, §3.10"
  },
  {
    "term": "Candidate",
    "section": 3,
    "where": "BRD §3.20, §3.18"
  },
  {
    "term": "Internal candidate",
    "section": 3,
    "where": "BRD §9; CR-061"
  },
  {
    "term": "Requisition HM",
    "section": 3,
    "where": "BRD §3.15"
  },
  {
    "term": "Debrief participants / debrief team",
    "section": 3,
    "where": "BRD §3.16; Spec Epic 6.2"
  },
  {
    "term": "Legal/Privacy/Records",
    "section": 3,
    "where": "BRD §8, Appendix B"
  },
  {
    "term": "Persona",
    "section": 3,
    "where": "BRD §12 (CR-040), §15"
  },
  {
    "term": "Hiring Request / request",
    "section": 5,
    "where": "Spec §3; BRD §3.1"
  },
  {
    "term": "Request creation (HRBP)",
    "section": 5,
    "where": "BRD §3.1, §13"
  },
  {
    "term": "HM certification",
    "section": 5,
    "where": "BRD §3.1, §13; CR-002"
  },
  {
    "term": "HRBP approval",
    "section": 5,
    "where": "BRD §3.1; CR-003"
  },
  {
    "term": "Returned request",
    "section": 5,
    "where": "BRD §3.1"
  },
  {
    "term": "Draft (request)",
    "section": 5,
    "where": "BRD §3.1"
  },
  {
    "term": "Pending HM Certification",
    "section": 5,
    "where": "BRD §3.1"
  },
  {
    "term": "HM Certified",
    "section": 5,
    "where": "BRD §3.1"
  },
  {
    "term": "Pending HRBP Approval",
    "section": 5,
    "where": "BRD §3.1"
  },
  {
    "term": "Approved (request)",
    "section": 5,
    "where": "BRD §3.1, §3.2"
  },
  {
    "term": "Dormant",
    "section": 5,
    "where": "BRD §3.1"
  },
  {
    "term": "Current JD / Job Description version",
    "section": 5,
    "where": "BRD §3.1"
  },
  {
    "term": "Required request fields",
    "section": 5,
    "where": "BRD §3.1"
  },
  {
    "term": "New/replacement",
    "section": 5,
    "where": "BRD §3.1, §7.2"
  },
  {
    "term": "Original/revised values",
    "section": 5,
    "where": "BRD §3.1; Spec Epic 1.1"
  },
  {
    "term": "Requisition / req",
    "section": 5,
    "where": "BRD §3.2; Email"
  },
  {
    "term": "Title (requisition)",
    "section": 5,
    "where": "Email; BRD §3.1"
  },
  {
    "term": "Req Creation Pending",
    "section": 5,
    "where": "BRD §3.2"
  },
  {
    "term": "Created (requisition)",
    "section": 5,
    "where": "BRD §3.2"
  },
  {
    "term": "Posted",
    "section": 5,
    "where": "BRD §3.2"
  },
  {
    "term": "Create/post",
    "section": 5,
    "where": "BRD §3.2, §13"
  },
  {
    "term": "Recruiter recommendation",
    "section": 5,
    "where": "BRD §3.2; CR-012"
  },
  {
    "term": "Recommended / Pending TA Manager / Assigned",
    "section": 5,
    "where": "BRD §3.2"
  },
  {
    "term": "Reassignment request",
    "section": 5,
    "where": "BRD §3.2, §8; CR-054"
  },
  {
    "term": "Reassign Recruiter",
    "section": 5,
    "where": "BRD §3.2, §13; DC-233"
  },
  {
    "term": "Go back to Requisitions",
    "section": 5,
    "where": "F-147; DC-232"
  },
  {
    "term": "Posting strategy",
    "section": 5,
    "where": "BRD §3.2, §3.5; CR-014"
  },
  {
    "term": "Posting type",
    "section": 5,
    "where": "BRD §3.1; CR-014"
  },
  {
    "term": "Compensation review",
    "section": 5,
    "where": "BRD §3.2; Spec Epic 7.1; CR-011"
  },
  {
    "term": "Pending / In Review / Finalized (Compensation)",
    "section": 5,
    "where": "BRD §3.2"
  },
  {
    "term": "Official recommendation / recommended range",
    "section": 5,
    "where": "BRD §3.2, §6"
  },
  {
    "term": "Grade, market data, recommendation, recommended range, commission structure",
    "section": 5,
    "where": "BRD §3.2"
  },
  {
    "term": "Hiring range",
    "section": 5,
    "where": "BRD §3.2, §6; F-154; DC-230"
  },
  {
    "term": "Salary grade · Internal range",
    "section": 5,
    "where": "BRD §6; DC-230"
  },
  {
    "term": "Market mid-point",
    "section": 5,
    "where": "BRD §3.2; DC-230"
  },
  {
    "term": "Recommended hiring range",
    "section": 5,
    "where": "BRD §3.2, §6; DC-230"
  },
  {
    "term": "Positioning · Below mid / At mid / Above mid · Positioning note",
    "section": 5,
    "where": "BRD §6; F-154; F-155; DC-230"
  },
  {
    "term": "Bonus target % · Commission",
    "section": 5,
    "where": "BRD §3.2, §6; DC-230"
  },
  {
    "term": "Working notes · Approval evidence",
    "section": 5,
    "where": "BRD §6; DC-230"
  },
  {
    "term": "Save · Finalize (Compensation review)",
    "section": 5,
    "where": "BRD §3.2; F-155; DC-230"
  },
  {
    "term": "PayFactors",
    "section": 5,
    "where": "BRD §3.1, §8"
  },
  {
    "term": "Phase plus milestone status model",
    "section": 5,
    "where": "BRD §12; Spec §3, Epic 8.1"
  },
  {
    "term": "Milestone",
    "section": 5,
    "where": "BRD §3.20, §3.21"
  },
  {
    "term": "Phase",
    "section": 5,
    "where": "BRD §7.2, §15"
  },
  {
    "term": "On Hold",
    "section": 5,
    "where": "BRD §3.21; Spec Epic 1.3; CR-037, CR-057"
  },
  {
    "term": "Cancellation Pending / Cancelled",
    "section": 5,
    "where": "BRD §3.21; CR-038, CR-056"
  },
  {
    "term": "Reopen Pending / Reopened",
    "section": 5,
    "where": "BRD §3.21; Spec Epic 1.3; CR-058"
  },
  {
    "term": "Hold/cancel/reopen request",
    "section": 5,
    "where": "BRD §8; Spec Epic 1.3"
  },
  {
    "term": "Reporting category",
    "section": 5,
    "where": "BRD §3.21"
  },
  {
    "term": "Offer Accepted → Ready for HRIS → HRIS Hired → Filled → Archived",
    "section": 5,
    "where": "BRD §3.21"
  },
  {
    "term": "Ready for HRIS",
    "section": 5,
    "where": "BRD §3.21; Spec Epic 8.1"
  },
  {
    "term": "Recruiting complete",
    "section": 5,
    "where": "Spec Epic 8.1"
  },
  {
    "term": "HRIS Hired / HRIS hire",
    "section": 5,
    "where": "BRD §3.21, §13; CR-059"
  },
  {
    "term": "HRIS confirmation",
    "section": 5,
    "where": "Spec Epic 8.1"
  },
  {
    "term": "Handoff / Handoff checklist",
    "section": 5,
    "where": "BRD §3.21, §13"
  },
  {
    "term": "Filled",
    "section": 5,
    "where": "BRD §3.21; Spec Epic 7.3; CR-034"
  },
  {
    "term": "Archived / Archive",
    "section": 5,
    "where": "BRD §8, §3.21; CR-060"
  },
  {
    "term": "Retention",
    "section": 5,
    "where": "BRD §8; CR-064"
  },
  {
    "term": "Openings",
    "section": 5,
    "where": "BRD §3.1"
  },
  {
    "term": "Days open",
    "section": 5,
    "where": "BRD §7; Email"
  },
  {
    "term": "Timing and budget",
    "section": 5,
    "where": "F-143; DC-234"
  },
  {
    "term": "Target start date",
    "section": 5,
    "where": "F-143; DC-234"
  },
  {
    "term": "Urgency · Normal / Urgent",
    "section": 5,
    "where": "F-143; DC-234"
  },
  {
    "term": "Target compensation range",
    "section": 5,
    "where": "F-143; BRD §3.2; DC-234"
  },
  {
    "term": "Position number",
    "section": 5,
    "where": "F-143; DC-234"
  },
  {
    "term": "Converted → R-#### / From Hiring Request RQ-####",
    "section": 5,
    "where": "Spec §3; F-148; DC-234"
  },
  {
    "term": "Intake",
    "section": 6,
    "where": "BRD §3.3, §3.4"
  },
  {
    "term": "Intake meeting template",
    "section": 6,
    "where": "BRD §3.3, §5.1"
  },
  {
    "term": "Intake Scheduled → In Progress → Draft Plan → Validation Failed or Ready → Finalized",
    "section": 6,
    "where": "BRD §3.4"
  },
  {
    "term": "Interview plan",
    "section": 6,
    "where": "BRD §2, §3.4; Spec Epic 3.1"
  },
  {
    "term": "TA-owned framework / level framework",
    "section": 6,
    "where": "BRD §3.4; CR-019"
  },
  {
    "term": "Level",
    "section": 6,
    "where": "BRD §3.15; Email"
  },
  {
    "term": "Round / rounds",
    "section": 6,
    "where": "BRD §3.4; Spec §3"
  },
  {
    "term": "Interviewer assignment",
    "section": 6,
    "where": "BRD §3.4; CR-020"
  },
  {
    "term": "ROOTS / the five ROOTS values",
    "section": 6,
    "where": "BRD §3.4, §5.3; Email; CR-006"
  },
  {
    "term": "Required skills / skills",
    "section": 6,
    "where": "BRD §3.4"
  },
  {
    "term": "Coverage",
    "section": 6,
    "where": "BRD §3.4, §5.3"
  },
  {
    "term": "Executive participation",
    "section": 6,
    "where": "BRD §3.4, §3.14"
  },
  {
    "term": "Assessment / case study",
    "section": 6,
    "where": "BRD §3.12; CR-022"
  },
  {
    "term": "Not Required / Required → Draft → Sent → Submitted → Reviewed → Completed/Withdrawn",
    "section": 6,
    "where": "BRD §3.12"
  },
  {
    "term": "Sent / due / completed / outcome (assessment)",
    "section": 6,
    "where": "BRD §3.12"
  },
  {
    "term": "Pre-intake preparation",
    "section": 6,
    "where": "BRD §3.4"
  },
  {
    "term": "Finalization notice",
    "section": 6,
    "where": "BRD §3.4"
  },
  {
    "term": "Editable suggestion",
    "section": 6,
    "where": "BRD §3.4"
  },
  {
    "term": "HM preferences & logistics",
    "section": 6,
    "where": "F-156; F-157; DC-231"
  },
  {
    "term": "HM availability",
    "section": 6,
    "where": "F-156; DC-231"
  },
  {
    "term": "Relocation package · Yes / No / Partial",
    "section": 6,
    "where": "F-157; DC-231"
  },
  {
    "term": "Work-from-home policy",
    "section": 6,
    "where": "F-157; DC-231"
  },
  {
    "term": "Travel · Willing to travel",
    "section": 6,
    "where": "F-157; DC-231"
  },
  {
    "term": "Logistics note",
    "section": 6,
    "where": "F-157; DC-231"
  },
  {
    "term": "ROOTS/skill assignments (a round)",
    "section": 6,
    "where": "BRD §3.4; F-163; DC-242"
  },
  {
    "term": "Candidate ID",
    "section": 7,
    "where": "BRD §10.2; CR-097"
  },
  {
    "term": "Candidate master / master profile",
    "section": 7,
    "where": "BRD §10.2"
  },
  {
    "term": "Candidate application",
    "section": 7,
    "where": "BRD §10.2"
  },
  {
    "term": "Active / Archived / Merged (profile)",
    "section": 7,
    "where": "BRD §3.5"
  },
  {
    "term": "Sourced → Qualified or Dispositioned",
    "section": 7,
    "where": "BRD §3.5"
  },
  {
    "term": "Resume upload / resume parsing",
    "section": 7,
    "where": "BRD §10.2; Spec Epic 2.2"
  },
  {
    "term": "Human confirmation",
    "section": 7,
    "where": "Spec Epic 2.2"
  },
  {
    "term": "Manual candidate entry",
    "section": 7,
    "where": "BRD §10.3"
  },
  {
    "term": "No-email exception",
    "section": 7,
    "where": "BRD §10.3"
  },
  {
    "term": "Duplicate prevention / duplicate review",
    "section": 7,
    "where": "BRD §10.1; CR-096"
  },
  {
    "term": "Potential match",
    "section": 7,
    "where": "BRD §10.1"
  },
  {
    "term": "Use existing / create distinct",
    "section": 7,
    "where": "BRD §10.1"
  },
  {
    "term": "Merge / recovery",
    "section": 7,
    "where": "BRD §10.1; Spec Epic 2.3"
  },
  {
    "term": "Source",
    "section": 7,
    "where": "BRD §10.2, §7"
  },
  {
    "term": "Internal/external flag",
    "section": 7,
    "where": "BRD §10.2, §7"
  },
  {
    "term": "Sourcing",
    "section": 7,
    "where": "BRD §3.5"
  },
  {
    "term": "Rediscovery",
    "section": 7,
    "where": "BRD §3.5; Spec Epic 8.2; CR-062"
  },
  {
    "term": "Finalists / alternates / silver medalists",
    "section": 7,
    "where": "BRD §3.5, §9"
  },
  {
    "term": "Talent community",
    "section": 7,
    "where": "BRD §3.5, §9; Email"
  },
  {
    "term": "Segment / tags",
    "section": 7,
    "where": "BRD §9"
  },
  {
    "term": "Internal mobility",
    "section": 7,
    "where": "BRD §9"
  },
  {
    "term": "Self-attestation",
    "section": 7,
    "where": "BRD §9"
  },
  {
    "term": "Candidate slate / slate submission",
    "section": 7,
    "where": "BRD §3.6"
  },
  {
    "term": "Draft Batch → Submitted → In HM Review → Completed/Overdue",
    "section": 7,
    "where": "BRD §3.6"
  },
  {
    "term": "HM review task / HM review SLA",
    "section": 7,
    "where": "BRD §3.6"
  },
  {
    "term": "Advance / Hold / Pass",
    "section": 7,
    "where": "BRD §3.7"
  },
  {
    "term": "Pending Review → Advanced/Held/Passed",
    "section": 7,
    "where": "BRD §3.7"
  },
  {
    "term": "Hold reason / age",
    "section": 7,
    "where": "BRD §3.7"
  },
  {
    "term": "Disposition (routing of Pass)",
    "section": 7,
    "where": "BRD §3.7"
  },
  {
    "term": "Recruiter screen",
    "section": 8,
    "where": "BRD §3.8"
  },
  {
    "term": "Screen Requested → Scheduled → Completed → Advance/Hold/Pass/Withdrawn",
    "section": 8,
    "where": "BRD §3.8"
  },
  {
    "term": "First contact / follow-up",
    "section": 8,
    "where": "BRD §3.8, §7"
  },
  {
    "term": "Withdrawal / withdrawal reason",
    "section": 8,
    "where": "BRD §3.8, §3.21; CR-035"
  },
  {
    "term": "Screen content and outcome",
    "section": 8,
    "where": "BRD §3.8"
  },
  {
    "term": "Screen (date) · first contact · follow-up",
    "section": 8,
    "where": "BRD §3.8"
  },
  {
    "term": "Withdrawal stage / withdrawal date",
    "section": 8,
    "where": "BRD §3.8, §7"
  },
  {
    "term": "Application exists (screen gate)",
    "section": 8,
    "where": "BRD §3.8"
  },
  {
    "term": "Authorized results (HM, Step 8)",
    "section": 8,
    "where": "BRD §3.8"
  },
  {
    "term": "Recruiter screen reminders · withdrawal closes pending schedule tasks",
    "section": 8,
    "where": "BRD §3.8"
  },
  {
    "term": "HM interview selection",
    "section": 8,
    "where": "BRD §3.9"
  },
  {
    "term": "Pending HM Selection → Advance/Hold/Pass; Advanced → HM Interview Scheduling Requested",
    "section": 8,
    "where": "BRD §3.9"
  },
  {
    "term": "HM interview",
    "section": 8,
    "where": "BRD §3.11, §5.1"
  },
  {
    "term": "Candidate decision (HM)",
    "section": 8,
    "where": "BRD §3.11"
  },
  {
    "term": "Decision time / decision timestamp",
    "section": 8,
    "where": "BRD §3.9"
  },
  {
    "term": "Invalid sequence",
    "section": 8,
    "where": "BRD §3.10; CR-077"
  },
  {
    "term": "Scheduling request",
    "section": 9,
    "where": "Spec Epic 5.1"
  },
  {
    "term": "Requested",
    "section": 9,
    "where": "BRD §4.2; CR-085"
  },
  {
    "term": "Scheduling in Progress",
    "section": 9,
    "where": "BRD §4.2, §3.3, §3.10"
  },
  {
    "term": "Awaiting Candidate Availability",
    "section": 9,
    "where": "BRD §4.2, §3.14"
  },
  {
    "term": "Awaiting Interviewer Availability",
    "section": 9,
    "where": "BRD §4.2"
  },
  {
    "term": "Scheduled",
    "section": 9,
    "where": "BRD §4.2"
  },
  {
    "term": "Reschedule Requested",
    "section": 9,
    "where": "BRD §4.2, §3.3; CR-087"
  },
  {
    "term": "Completed",
    "section": 9,
    "where": "BRD §4.2; Spec Epic 5.1"
  },
  {
    "term": "Cancelled",
    "section": 9,
    "where": "BRD §4.2"
  },
  {
    "term": "Ready to Schedule",
    "section": 9,
    "where": "BRD §3.14"
  },
  {
    "term": "Blocked for panel/coverage",
    "section": 9,
    "where": "BRD §3.14"
  },
  {
    "term": "Availability / availability search",
    "section": 9,
    "where": "BRD §3.3; CR-076"
  },
  {
    "term": "Proposed slots / proposed times",
    "section": 9,
    "where": "BRD §3.3"
  },
  {
    "term": "Free/busy",
    "section": 9,
    "where": "BRD §3.10"
  },
  {
    "term": "Working hours / OOF",
    "section": 9,
    "where": "BRD §5.1"
  },
  {
    "term": "Conflict / conflict detection",
    "section": 9,
    "where": "BRD §3.3, §3.10; CR-080, CR-091"
  },
  {
    "term": "Room / room selection / room reservation",
    "section": 9,
    "where": "BRD §3.3, §3.10"
  },
  {
    "term": "Time zone",
    "section": 9,
    "where": "BRD §3.3; Spec §3"
  },
  {
    "term": "Outlook event",
    "section": 9,
    "where": "BRD §3.10, §3.3; CR-088"
  },
  {
    "term": "Teams link",
    "section": 9,
    "where": "BRD §3.3, §5.1"
  },
  {
    "term": "Meeting template",
    "section": 9,
    "where": "BRD §5.1; CR-081"
  },
  {
    "term": "Delivery status",
    "section": 9,
    "where": "BRD §5.1, §3.3"
  },
  {
    "term": "Sync / sync failure / sync recovery",
    "section": 9,
    "where": "BRD §3.3; Spec Epic 5.2"
  },
  {
    "term": "Recovery task",
    "section": 9,
    "where": "BRD §3.3"
  },
  {
    "term": "Virtual / onsite / hybrid",
    "section": 9,
    "where": "BRD §3.14"
  },
  {
    "term": "Itinerary",
    "section": 9,
    "where": "BRD §3.14"
  },
  {
    "term": "Attendees",
    "section": 9,
    "where": "BRD §5.1; Spec Epic 5.1"
  },
  {
    "term": "Travel / travel task",
    "section": 9,
    "where": "BRD §3.14"
  },
  {
    "term": "Scheduling SLA / scheduling SLA risk",
    "section": 9,
    "where": "BRD §4.2; CR-090"
  },
  {
    "term": "Final Loop schedule",
    "section": 9,
    "where": "BRD §3.14"
  },
  {
    "term": "Offer call",
    "section": 9,
    "where": "BRD §5.1"
  },
  {
    "term": "No-response alert",
    "section": 9,
    "where": "BRD §3.10"
  },
  {
    "term": "Call held offline — continue · Held offline — continue · Held offline",
    "section": 9,
    "where": "F-158; DC-237"
  },
  {
    "term": "Meeting names on cards",
    "section": 9,
    "where": "BRD §5.1; DC-238"
  },
  {
    "term": "Respond · Accept / Tentative / Decline (a meeting invitation)",
    "section": 9,
    "where": "BRD §4.1, §5.1; Spec Epic 5.2; F-159; DC-238"
  },
  {
    "term": "Coordinator (who schedules a meeting)",
    "section": 9,
    "where": "BRD §3.3; F-161; DC-240"
  },
  {
    "term": "Request a reschedule · Reschedule request · Reschedule requested",
    "section": 9,
    "where": "BRD §4.2, §3.3; F-162; DC-241"
  },
  {
    "term": "Packet / Interview packet",
    "section": 10,
    "where": "BRD §3.13; CR-021"
  },
  {
    "term": "Packet Draft → Generated → Reviewed → Released",
    "section": 10,
    "where": "BRD §3.13"
  },
  {
    "term": "Release / Recruiter release",
    "section": 10,
    "where": "BRD §3.13; CR-021"
  },
  {
    "term": "Interview guidance",
    "section": 10,
    "where": "BRD §3.13, §5.2"
  },
  {
    "term": "Panel kickoff / kickoff email",
    "section": 10,
    "where": "BRD §3.13, §5.2; CR-073"
  },
  {
    "term": "One email / one versioned kickoff email",
    "section": 10,
    "where": "BRD §3.13; Spec Epic 4.1"
  },
  {
    "term": "Acknowledgment / accept / decline",
    "section": 10,
    "where": "BRD §3.13; CR-083, CR-086"
  },
  {
    "term": "Acknowledgment Pending / Accepted / Declined",
    "section": 10,
    "where": "BRD §3.13"
  },
  {
    "term": "Nonresponse",
    "section": 10,
    "where": "BRD §3.13, §7"
  },
  {
    "term": "Packet link / unique authorized packet link",
    "section": 10,
    "where": "BRD §3.13"
  },
  {
    "term": "App access",
    "section": 10,
    "where": "BRD §3.13, §5.3"
  },
  {
    "term": "Confidentiality",
    "section": 10,
    "where": "BRD §3.13"
  },
  {
    "term": "Panel change / panel-change workflow",
    "section": 10,
    "where": "BRD §3.13; Spec Epic 4.2; CR-074"
  },
  {
    "term": "Draft (panel change)",
    "section": 10,
    "where": "BRD §5.3; CR-075"
  },
  {
    "term": "Submitted",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Pending Recruiter Review",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Pending HM Review",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Blocked",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Approved",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Rejected",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Communicated",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Completed (panel change)",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Material panel structure change",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Standard SLA (24 hours)",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Expedited SLA (4 business hours)",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Emergency (immediate)",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "50% reminder / near-breach urgent reminder / breach dashboard risk",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Revalidate (coverage)",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Replacement (interviewer)",
    "section": 10,
    "where": "BRD §5.3"
  },
  {
    "term": "Final Interview Loop / Final Loop",
    "section": 11,
    "where": "BRD §3.14, §14; Spec Epic 5.3"
  },
  {
    "term": "Final Interview Loop · Round n (the round label)",
    "section": 11,
    "where": "BRD §3.14; Spec §3"
  },
  {
    "term": "Interview occurrence",
    "section": 11,
    "where": "BRD §3.15"
  },
  {
    "term": "Interview Scheduled / Completed / Scorecard Due",
    "section": 11,
    "where": "BRD §3.15"
  },
  {
    "term": "Scorecard",
    "section": 11,
    "where": "BRD §3.11, §3.15"
  },
  {
    "term": "Not Started → In Progress → Submitted/Past Due",
    "section": 11,
    "where": "BRD §3.11"
  },
  {
    "term": "Past Due",
    "section": 11,
    "where": "BRD §3.11; Spec Epic 6.1"
  },
  {
    "term": "Waived",
    "section": 11,
    "where": "Spec Epic 6.1"
  },
  {
    "term": "24-hour scorecard SLA / 24-hour rule",
    "section": 11,
    "where": "BRD §3.11, §3.15; CR-023"
  },
  {
    "term": "Rating",
    "section": 11,
    "where": "BRD §3.15"
  },
  {
    "term": "Unassessed",
    "section": 11,
    "where": "BRD §3.17; Spec Epic 6.2"
  },
  {
    "term": "Evidence",
    "section": 11,
    "where": "BRD §3.11, §3.16"
  },
  {
    "term": "Recommendation (scorecard)",
    "section": 11,
    "where": "BRD §12, §3.15, §3.17; Playbook p.7"
  },
  {
    "term": "No Hire",
    "section": 11,
    "where": "BRD §3.15; Playbook p.7"
  },
  {
    "term": "Hire",
    "section": 11,
    "where": "BRD §3.17; Playbook p.7"
  },
  {
    "term": "Corporate Interview Playbook",
    "section": 11,
    "where": "Playbook p.1–7 (13 Oct)"
  },
  {
    "term": "Candidate · Title · Interviewer · Date (the header box)",
    "section": 11,
    "where": "Playbook p.1"
  },
  {
    "term": "Page n of N",
    "section": 11,
    "where": "Playbook p.1–7"
  },
  {
    "term": "Skills (stepper chip)",
    "section": 11,
    "where": "Playbook p.6; BRD §3.15 \"assigned values/skills\""
  },
  {
    "term": "Standard assessed",
    "section": 11,
    "where": "Playbook p.1–5"
  },
  {
    "term": "5 = Strong",
    "section": 11,
    "where": "Playbook p.1–5"
  },
  {
    "term": "1 = Weak",
    "section": 11,
    "where": "Playbook p.1–5"
  },
  {
    "term": "Behavioral interview questions",
    "section": 11,
    "where": "Playbook p.1–5"
  },
  {
    "term": "Graded score rating (select one)",
    "section": 11,
    "where": "Playbook p.1–5"
  },
  {
    "term": "Required observations / evidence",
    "section": 11,
    "where": "Playbook p.1–5"
  },
  {
    "term": "Values matrix",
    "section": 11,
    "where": "Playbook p.1–5"
  },
  {
    "term": "Role-specific competency assessment",
    "section": 11,
    "where": "Playbook p.6"
  },
  {
    "term": "FIT",
    "section": 11,
    "where": "Playbook p.6"
  },
  {
    "term": "What strong performance looks like",
    "section": 11,
    "where": "Playbook p.6"
  },
  {
    "term": "Strong observations",
    "section": 11,
    "where": "Playbook p.6"
  },
  {
    "term": "Gaps detected",
    "section": 11,
    "where": "Playbook p.6"
  },
  {
    "term": "Notes",
    "section": 11,
    "where": "Playbook p.6"
  },
  {
    "term": "Score grade",
    "section": 11,
    "where": "Playbook p.6"
  },
  {
    "term": "Competencies portal • Functional fit",
    "section": 11,
    "where": "Playbook p.6"
  },
  {
    "term": "Hiring recommendation & justification",
    "section": 11,
    "where": "Playbook p.7"
  },
  {
    "term": "Strong Hire",
    "section": 11,
    "where": "Playbook p.7; Tejesh 13 Oct 08:29 (R4)"
  },
  {
    "term": "Consider Other Role",
    "section": 11,
    "where": "Playbook p.7; Tejesh 13 Oct 08:29 (R4)"
  },
  {
    "term": "Suggested role",
    "section": 11,
    "where": "Playbook guide (13 Oct)"
  },
  {
    "term": "Why?",
    "section": 11,
    "where": "Playbook guide (13 Oct)"
  },
  {
    "term": "Scoring summary & rubric",
    "section": 11,
    "where": "Playbook p.7"
  },
  {
    "term": "Caution / Consider",
    "section": 11,
    "where": "Playbook p.7"
  },
  {
    "term": "Average core score",
    "section": 11,
    "where": "Playbook p.7"
  },
  {
    "term": "Justification & rationale",
    "section": 11,
    "where": "Playbook p.7"
  },
  {
    "term": "Manager handoff & coaching remarks",
    "section": 11,
    "where": "Playbook p.7"
  },
  {
    "term": "Sign",
    "section": 11,
    "where": "Playbook p.7"
  },
  {
    "term": "Record verification",
    "section": 11,
    "where": "Playbook p.7"
  },
  {
    "term": "Synthesis hub • Final decision record",
    "section": 11,
    "where": "Playbook p.7"
  },
  {
    "term": "earlier scale (marker)",
    "section": 11,
    "where": "Tejesh 13 Oct 08:29 (R4)"
  },
  {
    "term": "Concern flag",
    "section": 11,
    "where": "BRD §3.15; CR-024"
  },
  {
    "term": "Sr Director and below",
    "section": 11,
    "where": "BRD §3.15, §3.17; CR-027"
  },
  {
    "term": "VP+",
    "section": 11,
    "where": "BRD §3.15, §3.17, §3.19"
  },
  {
    "term": "Independent feedback / independence",
    "section": 11,
    "where": "BRD §3.15; Spec Epic 6.1"
  },
  {
    "term": "Escalation (interviewer nonresponse)",
    "section": 11,
    "where": "BRD §3.15, §3.6; CR-047"
  },
  {
    "term": "Reminder",
    "section": 11,
    "where": "BRD §12, §3.11"
  },
  {
    "term": "Assigned values/skills",
    "section": 11,
    "where": "BRD §3.15"
  },
  {
    "term": "Debrief readiness / Ready / Not Ready",
    "section": 11,
    "where": "Spec Epic 5.3; BRD §3.16; CR-078, CR-089"
  },
  {
    "term": "Missing control",
    "section": 11,
    "where": "Spec Epic 5.3; BRD §3.16"
  },
  {
    "term": "Missing/conflicting evidence",
    "section": 11,
    "where": "BRD §3.16"
  },
  {
    "term": "Waiting for Inputs → Compiling → Recruiter Review → Ready for Debrief or Blocked",
    "section": 11,
    "where": "BRD §3.16"
  },
  {
    "term": "Recruiter review (summary)",
    "section": 11,
    "where": "BRD §3.16"
  },
  {
    "term": "Formal debrief / hybrid formal debrief",
    "section": 11,
    "where": "BRD §3.17; CR-007, CR-026"
  },
  {
    "term": "Required attendees",
    "section": 11,
    "where": "BRD §3.17; CR-025"
  },
  {
    "term": "Missing attendee",
    "section": 11,
    "where": "BRD §3.17"
  },
  {
    "term": "Not Ready → Scheduled → Roll Call → Reveal → Discussion → Alignment → Outcome Recorded/Blocked",
    "section": 11,
    "where": "BRD §3.17"
  },
  {
    "term": "Roll Call",
    "section": 11,
    "where": "BRD §3.17"
  },
  {
    "term": "Reveal",
    "section": 11,
    "where": "BRD §3.17"
  },
  {
    "term": "Alignment",
    "section": 11,
    "where": "BRD §3.17; Spec Epic 6.2"
  },
  {
    "term": "Outcome Recorded",
    "section": 11,
    "where": "BRD §3.17"
  },
  {
    "term": "Own-score revision / recommendation revision",
    "section": 11,
    "where": "BRD §3.17; Spec Epic 6.2"
  },
  {
    "term": "Rationale",
    "section": 11,
    "where": "Spec Epic 6.2"
  },
  {
    "term": "Unanimous Hire",
    "section": 11,
    "where": "BRD §3.17"
  },
  {
    "term": "Debrief outcomes",
    "section": 11,
    "where": "BRD §3.17; Spec Epic 6.2; CR-029"
  },
  {
    "term": "Primary",
    "section": 11,
    "where": "BRD §3.17, §3.21"
  },
  {
    "term": "Alternates / alternate designation",
    "section": 11,
    "where": "BRD §3.17; Spec Epic 7.3; CR-030"
  },
  {
    "term": "Continue",
    "section": 11,
    "where": "BRD §3.17"
  },
  {
    "term": "Reopen",
    "section": 11,
    "where": "BRD §3.17"
  },
  {
    "term": "Additional-interview exception / exception round",
    "section": 11,
    "where": "BRD §3.17; CR-028"
  },
  {
    "term": "Disposition others",
    "section": 11,
    "where": "BRD §3.17"
  },
  {
    "term": "Unassessed competency",
    "section": 11,
    "where": "BRD §3.17"
  },
  {
    "term": "Administrative correction",
    "section": 11,
    "where": "BRD §3.17, §3.11"
  },
  {
    "term": "Selection",
    "section": 11,
    "where": "BRD §2, §11"
  },
  {
    "term": "Reference check (optional)",
    "section": 12,
    "where": "BRD §3.18"
  },
  {
    "term": "Not Required / Required → Requested → In Progress → Completed/Unable to Complete",
    "section": 12,
    "where": "BRD §3.18"
  },
  {
    "term": "Provider",
    "section": 12,
    "where": "BRD §3.18"
  },
  {
    "term": "Requirement flag · Not Required / Required",
    "section": 12,
    "where": "BRD §3.18"
  },
  {
    "term": "Owner · requested / completed dates · outcome · notes",
    "section": 12,
    "where": "BRD §3.18"
  },
  {
    "term": "Policy-controlled access (reference check)",
    "section": 12,
    "where": "BRD §3.18"
  },
  {
    "term": "Reference check task and readiness",
    "section": 12,
    "where": "BRD §3.18"
  },
  {
    "term": "Offer > Reference Check screen",
    "section": 12,
    "where": "BRD §3.18"
  },
  {
    "term": "Offer package",
    "section": 12,
    "where": "BRD §2, §3.19; CR-031"
  },
  {
    "term": "Draft → Pending Approvals → Ready for Verbal Offer or Rejected/Revision Required",
    "section": 12,
    "where": "BRD §3.19"
  },
  {
    "term": "Conditional approvals / approval requirement",
    "section": 12,
    "where": "BRD §3.19"
  },
  {
    "term": "Standard offer",
    "section": 12,
    "where": "BRD §3.19"
  },
  {
    "term": "Sign-on / relocation",
    "section": 12,
    "where": "BRD §3.19"
  },
  {
    "term": "VP+ LTI",
    "section": 12,
    "where": "BRD §3.19"
  },
  {
    "term": "Offer readiness",
    "section": 12,
    "where": "Spec Epic 7.2; BRD §3.19"
  },
  {
    "term": "Verbal offer / Verbal Extended",
    "section": 12,
    "where": "BRD §3.19, §3.20"
  },
  {
    "term": "Written Sent",
    "section": 12,
    "where": "BRD §3.20"
  },
  {
    "term": "Awaiting Candidate",
    "section": 12,
    "where": "BRD §3.20"
  },
  {
    "term": "Negotiation / Offer Negotiation",
    "section": 12,
    "where": "BRD §3.20; CR-032"
  },
  {
    "term": "Counter / request",
    "section": 12,
    "where": "BRD §3.20"
  },
  {
    "term": "Revised Offer",
    "section": 12,
    "where": "BRD §3.20; Spec Epic 7.3"
  },
  {
    "term": "Accepted / Offer Accepted",
    "section": 12,
    "where": "BRD §3.20; CR-034"
  },
  {
    "term": "Declined / offer decline",
    "section": 12,
    "where": "BRD §3.20; CR-033, CR-036, CR-039"
  },
  {
    "term": "Next path (alternate to offer / continue / reopen / close)",
    "section": 12,
    "where": "BRD §3.20; Spec Epic 7.3"
  },
  {
    "term": "Candidate decision",
    "section": 12,
    "where": "BRD §3.20"
  },
  {
    "term": "Candidate-facing status",
    "section": 12,
    "where": "BRD §3.20"
  },
  {
    "term": "Background check",
    "section": 12,
    "where": "BRD §3.21, §8"
  },
  {
    "term": "Start / start date",
    "section": 12,
    "where": "BRD §7.1"
  },
  {
    "term": "Recommendation / recommended hiring range",
    "section": 13,
    "where": "BRD §6"
  },
  {
    "term": "Proposed base / bonus / commission",
    "section": 13,
    "where": "BRD §6"
  },
  {
    "term": "Sign-on / relocation / LTI request and status",
    "section": 13,
    "where": "BRD §6"
  },
  {
    "term": "Salary grade",
    "section": 13,
    "where": "BRD §6"
  },
  {
    "term": "Market data / internal range / positioning",
    "section": 13,
    "where": "BRD §6"
  },
  {
    "term": "Internal equity / working notes / approval evidence",
    "section": 13,
    "where": "BRD §6"
  },
  {
    "term": "Full / Yes / No / own-action only",
    "section": 13,
    "where": "BRD §6, §3.19"
  },
  {
    "term": "Restricted field",
    "section": 13,
    "where": "BRD §6, §3.19"
  },
  {
    "term": "Final terms",
    "section": 13,
    "where": "BRD §3.19"
  },
  {
    "term": "Portfolio (report)",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Pipeline (report)",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Offer (report)",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Candidate experience (report)",
    "section": 14,
    "where": "BRD §7; CR-045"
  },
  {
    "term": "HM responsiveness (report)",
    "section": 14,
    "where": "BRD §7; CR-042"
  },
  {
    "term": "Recruiter operations (report)",
    "section": 14,
    "where": "BRD §7; CR-044"
  },
  {
    "term": "Coordinator operations (report)",
    "section": 14,
    "where": "BRD §7; CR-082"
  },
  {
    "term": "Candidates by stage",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Qualified volume",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Time in stage",
    "section": 14,
    "where": "BRD §7, §7.2"
  },
  {
    "term": "Interview-to-offer",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Source of hire / interview / offer",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Acceptance/negotiation rate",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Decline reasons",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Days between stages",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Days to disposition",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Undispositioned / alternate closure",
    "section": 14,
    "where": "BRD §7, §3.21"
  },
  {
    "term": "Debrief participation",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Assignment-to-intake / first candidate",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Time to schedule each meeting type",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Debrief SLA",
    "section": 14,
    "where": "BRD §7"
  },
  {
    "term": "Time to Acceptance",
    "section": 14,
    "where": "BRD §7.1; CR-048"
  },
  {
    "term": "Time to Fill",
    "section": 14,
    "where": "BRD §7.1; CR-048"
  },
  {
    "term": "Acceptance to HRIS",
    "section": 14,
    "where": "BRD §7.1"
  },
  {
    "term": "Acceptance to Start",
    "section": 14,
    "where": "BRD §7.1"
  },
  {
    "term": "Calendar Time",
    "section": 14,
    "where": "BRD §7.1"
  },
  {
    "term": "Active Time / active days",
    "section": 14,
    "where": "BRD §7.1, §7"
  },
  {
    "term": "Days on Hold / hold days",
    "section": 14,
    "where": "BRD §7.1, §7"
  },
  {
    "term": "60/75/90 targets",
    "section": 14,
    "where": "BRD §7.1"
  },
  {
    "term": "SLA",
    "section": 14,
    "where": "BRD §7.1, §8"
  },
  {
    "term": "Filters",
    "section": 14,
    "where": "BRD §7.2; CR-051"
  },
  {
    "term": "Brand / function / department / job family / area of interest / location / level",
    "section": 14,
    "where": "BRD §7.2; Email"
  },
  {
    "term": "Standardized reasons",
    "section": 14,
    "where": "BRD §7.2; Spec Epic 9.3"
  },
  {
    "term": "Reporting event",
    "section": 14,
    "where": "Spec §3, Epic 9.2"
  },
  {
    "term": "Power BI-ready model",
    "section": 14,
    "where": "BRD §8"
  },
  {
    "term": "Open Requisitions · Active Candidates · Average Time To Fill · Offers Accepted · Pipeline Health Score",
    "section": 14,
    "where": "Email"
  },
  {
    "term": "Field-level ownership",
    "section": 15,
    "where": "BRD §8; CR-053"
  },
  {
    "term": "Shared field",
    "section": 15,
    "where": "BRD §8"
  },
  {
    "term": "Audit / audit trail / audit event",
    "section": 15,
    "where": "BRD §8; CR-050"
  },
  {
    "term": "Reason",
    "section": 15,
    "where": "BRD passim"
  },
  {
    "term": "Override / administrative override",
    "section": 15,
    "where": "BRD §8, §3.1, §13; CR-055"
  },
  {
    "term": "No substantive override",
    "section": 15,
    "where": "BRD §13"
  },
  {
    "term": "Workflow correction",
    "section": 15,
    "where": "BRD §13"
  },
  {
    "term": "Configuration value / configuration version",
    "section": 15,
    "where": "Spec §3, Epic 9.3; CR-066"
  },
  {
    "term": "Thresholds",
    "section": 15,
    "where": "BRD §3.3; Spec Epic 9.3"
  },
  {
    "term": "Taxonomies / reason lists / templates / segments / strategies",
    "section": 15,
    "where": "BRD §8"
  },
  {
    "term": "Notification / notification event",
    "section": 15,
    "where": "Spec §2; BRD §3.6"
  },
  {
    "term": "Idempotent",
    "section": 15,
    "where": "Spec §2, Epic 4.1"
  },
  {
    "term": "Correlation ID",
    "section": 15,
    "where": "Spec §3"
  },
  {
    "term": "Integration / phased integration roadmap",
    "section": 15,
    "where": "BRD §8; CR-063"
  },
  {
    "term": "ADP / HRIS",
    "section": 15,
    "where": "BRD §10.2, §3.21"
  },
  {
    "term": "LinkedIn Recruiter / job boards / referral systems",
    "section": 15,
    "where": "BRD §10.2"
  },
  {
    "term": "Server-side authorization",
    "section": 15,
    "where": "Spec §2"
  },
  {
    "term": "Optimistic concurrency",
    "section": 15,
    "where": "Spec §3"
  },
  {
    "term": "Immutable system-generated ID",
    "section": 15,
    "where": "Spec §2"
  },
  {
    "term": "Accessibility",
    "section": 15,
    "where": "Spec §13; Email"
  },
  {
    "term": "Create request",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Certify request/JD",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Create/post req",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Assign/reassign Recruiter",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Edit interview plan",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Schedule meetings",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Full compensation data",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Scorecard",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Debrief decision",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Offer package",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Hold/cancel/reopen",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Talent community",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Candidate create/merge",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Archive/reporting",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "HRIS hire",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Access words",
    "section": 16,
    "where": "BRD §13"
  },
  {
    "term": "Create (request) · Certify · Approve · Return",
    "section": 17,
    "where": "BRD §3.1"
  },
  {
    "term": "Create/post · Assign · Reassign · Request reassignment",
    "section": 17,
    "where": "BRD §3.2"
  },
  {
    "term": "Finalize (plan / recommendation)",
    "section": 17,
    "where": "BRD §3.4, §3.2"
  },
  {
    "term": "Submit (slate / scorecard / request)",
    "section": 17,
    "where": "BRD §3.6, §3.11"
  },
  {
    "term": "Advance · Hold · Pass",
    "section": 17,
    "where": "BRD §3.7"
  },
  {
    "term": "Select (for HM interview)",
    "section": 17,
    "where": "BRD §3.9"
  },
  {
    "term": "Schedule · Reschedule · Cancel",
    "section": 17,
    "where": "BRD §3.3"
  },
  {
    "term": "Propose slots",
    "section": 17,
    "where": "Spec Epic 5.2"
  },
  {
    "term": "Review / Release (packets)",
    "section": 17,
    "where": "BRD §3.13"
  },
  {
    "term": "Accept / Decline (panel)",
    "section": 17,
    "where": "BRD §3.13"
  },
  {
    "term": "Revoke / Regenerate",
    "section": 17,
    "where": "BRD §5.3"
  },
  {
    "term": "Reveal · Discuss · Revise own score · Align · Record outcome",
    "section": 17,
    "where": "Spec Epic 6.2; BRD §3.17"
  },
  {
    "term": "Prepare (offer package) · Approve · Extend verbal offer · Send written · Counter · Revise · Accept · Decline",
    "section": 17,
    "where": "BRD §3.19, §3.20; Spec Epic 7.2"
  },
  {
    "term": "Disposition (verb)",
    "section": 17,
    "where": "BRD §3.21"
  },
  {
    "term": "Validate handoff · Confirm HRIS · Complete",
    "section": 17,
    "where": "BRD §3.21, §13"
  },
  {
    "term": "Designate (talent community)",
    "section": 17,
    "where": "Spec Epic 8.2"
  },
  {
    "term": "Request hold / cancel / reopen",
    "section": 17,
    "where": "Spec Epic 1.3"
  },
  {
    "term": "Upload · Validate · Parse · Review/edit · Duplicate check · Save",
    "section": 17,
    "where": "Spec Epic 2.2"
  },
  {
    "term": "Merge · Recover (unmerge)",
    "section": 17,
    "where": "BRD §10.3"
  },
  {
    "term": "Edit · Dismiss · Correct (the assistant's form-fill proposals)",
    "section": 17,
    "where": "Spec Epic 10; Tejesh 13 Oct 17:11 (R7)"
  },
  {
    "term": "Drill down · Export · Save view",
    "section": 17,
    "where": "Spec Epic 9.2"
  },
  {
    "term": "Retry (sync)",
    "section": 17,
    "where": "BRD §3.3"
  },
  {
    "term": "Remind",
    "section": 17,
    "where": "BRD §3.9, §3.6"
  },
  {
    "term": "Schedule rounds",
    "section": 17,
    "where": "BRD §3.14"
  }
];

export const ROLES: readonly { readonly name: string; readonly abbr: string | null }[] = [
  {
    "name": "Hiring Manager",
    "abbr": "HM"
  },
  {
    "name": "Recruiter",
    "abbr": null
  },
  {
    "name": "Coordinator",
    "abbr": null
  },
  {
    "name": "HR Business Partner",
    "abbr": "HRBP"
  },
  {
    "name": "Compensation",
    "abbr": "Comp"
  },
  {
    "name": "Interviewer",
    "abbr": null
  },
  {
    "name": "TA Manager",
    "abbr": "TA Mgr"
  },
  {
    "name": "Admin",
    "abbr": null
  }
];

export const ACTIONS = [
  "Create",
  "Certify",
  "Approve",
  "Return",
  "Create/post",
  "Assign",
  "Reassign",
  "Request reassignment",
  "Finalize",
  "Submit",
  "Advance",
  "Hold",
  "Pass",
  "Select",
  "Schedule",
  "Reschedule",
  "Cancel",
  "Propose slots",
  "Review",
  "Release",
  "Accept",
  "Decline",
  "Revoke",
  "Regenerate",
  "Reveal",
  "Discuss",
  "Revise own score",
  "Align",
  "Record outcome",
  "Prepare",
  "Extend verbal offer",
  "Send written",
  "Counter",
  "Revise",
  "Disposition",
  "Validate handoff",
  "Confirm HRIS",
  "Complete",
  "Designate",
  "Request hold / cancel / reopen",
  "Upload",
  "Validate",
  "Parse",
  "Review/edit",
  "Duplicate check",
  "Save",
  "Merge",
  "Recover",
  "Edit",
  "Dismiss",
  "Correct",
  "Drill down",
  "Export",
  "Save view",
  "Retry",
  "Remind",
  "Schedule rounds"
] as const;

export const ACCESS_WORDS = [
  "Yes",
  "No",
  "View",
  "Edit",
  "Edit/Approve",
  "Create/Edit",
  "Approve",
  "Assign",
  "Request",
  "Request/notified",
  "View/override",
  "Joint",
  "Consulted",
  "Admin support",
  "Participate",
  "Full",
  "Full/Edit",
  "Limited",
  "None",
  "Operational",
  "HM own",
  "Own only",
  "No substantive override",
  "Required",
  "Facilitates",
  "No vote",
  "Oversight",
  "Prepare",
  "Recommend/conditional",
  "Manage",
  "Authorized",
  "Admin",
  "Create/Review",
  "Create/Admin support",
  "Own reqs",
  "Assigned/Operational",
  "Assigned active only",
  "Supported org",
  "Comp scope",
  "Enterprise",
  "Validate/Complete",
  "Record for",
  "Record for / correction"
] as const;

export const ACCESS_WORDS_QUOTE = "Yes · No · View · Edit · Edit/Approve · Create/Edit · Approve · Assign · Request · Request/notified · View/override · Joint · Consulted · Admin support · Participate · Full · Full/Edit · Limited · None · Operational · HM own · Own only · No substantive override · Required · Facilitates · No vote · Oversight · Prepare · Recommend/conditional · Manage · Authorized · Admin · Create/Review · Create/Admin support · Own reqs · Assigned/Operational · Assigned active only · Supported org · Comp scope · Enterprise · Validate/Complete · Record for · Record for / correction" as const;

export const NAV_LABELS: readonly { readonly destination: string; readonly label: string }[] = [
  {
    "destination": "Home",
    "label": "Home"
  },
  {
    "destination": "Action Center",
    "label": "Action Center"
  },
  {
    "destination": "Requisitions",
    "label": "Requisitions"
  },
  {
    "destination": "Candidates",
    "label": "Candidates"
  },
  {
    "destination": "Pipeline",
    "label": "Pipeline"
  },
  {
    "destination": "Interviews",
    "label": "Interviews"
  },
  {
    "destination": "Coordinator Workbench",
    "label": "Coordinator Workbench"
  },
  {
    "destination": "Talent community",
    "label": "Talent community"
  },
  {
    "destination": "Approvals",
    "label": "Approvals"
  },
  {
    "destination": "Reports",
    "label": "Reports"
  },
  {
    "destination": "Settings",
    "label": "Settings"
  }
];

export const STEPS: readonly { readonly n: number; readonly label: string }[] = [
  {
    "n": 1,
    "label": "HRBP request creation, HM certification, HRBP approval"
  },
  {
    "n": 2,
    "label": "Coordinator creates/posts; TA Manager assigns Recruiter; Compensation starts in parallel"
  },
  {
    "n": 3,
    "label": "Coordinator scheduling via Outlook/Teams"
  },
  {
    "n": 4,
    "label": "Intake and interview-plan finalization"
  },
  {
    "n": 5,
    "label": "Sourcing and candidate identification"
  },
  {
    "n": 6,
    "label": "Candidate slate submission"
  },
  {
    "n": 7,
    "label": "HM advance/hold/pass"
  },
  {
    "n": 8,
    "label": "Recruiter screens"
  },
  {
    "n": 9,
    "label": "HM interview selection"
  },
  {
    "n": 10,
    "label": "Coordinator scheduling"
  },
  {
    "n": 11,
    "label": "HM interview, scorecard, decision"
  },
  {
    "n": 12,
    "label": "Assessment/case study"
  },
  {
    "n": 13,
    "label": "Plan, packets, panel kickoff"
  },
  {
    "n": 14,
    "label": "Schedule Final Interview Loop"
  },
  {
    "n": 15,
    "label": "Final Interview Loop and scorecards"
  },
  {
    "n": 16,
    "label": "Candidate summary and debrief preparation"
  },
  {
    "n": 17,
    "label": "Formal debrief and selection"
  },
  {
    "n": 18,
    "label": "Optional reference check"
  },
  {
    "n": 19,
    "label": "Offer package and conditional approvals"
  },
  {
    "n": 20,
    "label": "Offer, negotiation, acceptance or decline"
  },
  {
    "n": 21,
    "label": "Disposition, HRIS handoff, filled, closure, archive"
  }
];

export const PENDING: readonly { readonly text: string; readonly ref: string }[] = [
  {
    "text": "Renege",
    "ref": "G §23.2"
  },
  {
    "text": "acceptance reversal",
    "ref": "G §23.2"
  },
  {
    "text": "Health display",
    "ref": "G §23.3"
  },
  {
    "text": "Talent Pools",
    "ref": "G §23.4"
  },
  {
    "text": "Receipt",
    "ref": "G §23.5"
  },
  {
    "text": "Scheduling in Progress",
    "ref": "G §23.6"
  },
  {
    "text": "Awaiting Candidate Availability",
    "ref": "G §23.6"
  },
  {
    "text": "Awaiting Interviewer Availability",
    "ref": "G §23.6"
  },
  {
    "text": "Final Loop",
    "ref": "G §23.7"
  },
  {
    "text": "Final Interview Loop · Round {n}",
    "ref": "G §23.8"
  },
  {
    "text": "Recorded · audit event",
    "ref": "Q-E15"
  },
  {
    "text": "Nothing needs action",
    "ref": "Q-E15"
  },
  {
    "text": "Certification required first",
    "ref": "Q-E15"
  },
  {
    "text": "Edit profile",
    "ref": "Q-E15"
  },
  {
    "text": "Link to requisition",
    "ref": "Q-E15"
  },
  {
    "text": "Reuse an existing profile",
    "ref": "Q-E15"
  },
  {
    "text": "Review parsed values",
    "ref": "Q-E15"
  },
  {
    "text": "Decline this interview",
    "ref": "Q-E15"
  },
  {
    "text": "Keep this interview",
    "ref": "Q-E15"
  },
  {
    "text": "VP+ rule applied",
    "ref": "Q-E15"
  },
  {
    "text": "Access to this packet was revoked on {date}",
    "ref": "Q-E15"
  },
  {
    "text": "Scheduling already requested",
    "ref": "Q-E15"
  },
  {
    "text": "Recovery is available to TA Admin and HR Systems Admin",
    "ref": "Q-E15"
  },
  {
    "text": "Show availability",
    "ref": "Q-E15"
  },
  {
    "text": "Candidate-facing status: …",
    "ref": "Q-E15"
  },
  {
    "text": "To schedule",
    "ref": "Q-E15"
  },
  {
    "text": "Clear",
    "ref": "Q-E15"
  },
  {
    "text": "Scheduling requested · with Coordinator",
    "ref": "Q-E15"
  },
  {
    "text": "Start review",
    "ref": "Q-E15"
  },
  {
    "text": "Start the review to enter grade and range",
    "ref": "Q-E15"
  },
  {
    "text": "Min",
    "ref": "Q-E15"
  },
  {
    "text": "Max",
    "ref": "Q-E15"
  },
  {
    "text": "Currency",
    "ref": "Q-E15"
  },
  {
    "text": "No Compensation review is {status}",
    "ref": "Q-E15"
  },
  {
    "text": "Unassessed",
    "ref": "Q-E15"
  },
  {
    "text": "Every round in use has an interviewer",
    "ref": "Q-E15"
  },
  {
    "text": "Assessment decided",
    "ref": "Q-E15"
  },
  {
    "text": "Executive participation decided",
    "ref": "Q-E15"
  },
  {
    "text": "Open",
    "ref": "Q-E15"
  },
  {
    "text": "Open profile",
    "ref": "Q-E15"
  },
  {
    "text": "Print",
    "ref": "Q-E15"
  },
  {
    "text": "Candidate itinerary",
    "ref": "Q-E15"
  },
  {
    "text": "Teams link",
    "ref": "Q-E15"
  },
  {
    "text": "Within the internal range",
    "ref": "Q-E15"
  },
  {
    "text": "Below the internal range",
    "ref": "Q-E15"
  },
  {
    "text": "Above the internal range",
    "ref": "Q-E15"
  },
  {
    "text": "Max is below Min",
    "ref": "Q-E15"
  },
  {
    "text": "At most {max} characters",
    "ref": "Q-E15"
  },
  {
    "text": "Between {min} and {max}",
    "ref": "Q-E15"
  },
  {
    "text": "{min} – {max} {currency} · mid {mid}",
    "ref": "Q-E15"
  },
  {
    "text": "Finalize freezes this version: the grade, the range, the positioning, bonus, commission, notes and evidence. The range goes to the requisition.",
    "ref": "Q-E15"
  },
  {
    "text": "Remove every window to change the length",
    "ref": "Q-E15"
  },
  {
    "text": "At most {max} windows",
    "ref": "Q-E15"
  },
  {
    "text": "A working day after today",
    "ref": "Q-E15"
  },
  {
    "text": "Schedule intake — {title}",
    "ref": "Q-E15"
  },
  {
    "text": "Held offline {date} — Part 2 is open.",
    "ref": "Q-E15"
  },
  {
    "text": "{actor} recorded the {meeting} as held offline · {reason}",
    "ref": "Q-E15"
  },
  {
    "text": "{actor} recorded the {meeting} as held offline — {title}",
    "ref": "Q-E15"
  },
  {
    "text": "Held at cannot be in the future",
    "ref": "Q-E15"
  },
  {
    "text": "Copy Teams link",
    "ref": "Q-E15"
  },
  {
    "text": "Exceptional evidence across the assigned values and skills; move forward with confidence.",
    "ref": "Q-E15"
  },
  {
    "text": "Clear, confident recommendation to move forward.",
    "ref": "Q-E15"
  },
  {
    "text": "Not recommended for this role; consider the candidate for another position — name the role below.",
    "ref": "Q-E15"
  },
  {
    "text": "Do not recommend moving forward for this role.",
    "ref": "Q-E15"
  },
  {
    "text": "Rescheduled",
    "ref": "T-8"
  },
  {
    "text": "Current",
    "ref": "T-8"
  },
  {
    "text": "Previous version",
    "ref": "T-8"
  },
  {
    "text": "Superseded",
    "ref": "Q-E16"
  },
  {
    "text": "Disposition & handoff",
    "ref": "Q-E16"
  },
  {
    "text": "Closure",
    "ref": "Q-E16"
  }
];

export const FORBIDDEN: readonly ForbiddenEntry[] = [
  { "text": "Talent Acquisition Mission Control", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Talent Acquisition Mission Control(?![\\p{L}\\p{N}_])" 




},
  { "text": "Mission Control", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Mission Control(?![\\p{L}\\p{N}_])" 




},
  { "text": "Today", "mode": "label", "pattern": "^(?:Today)$" 




},
  { "text": "Needs you", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Needs you(?![\\p{L}\\p{N}_])" 




},
  { "text": "Attention Required", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Attention Required(?![\\p{L}\\p{N}_])" 




},
  { "text": "Pending Others", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Pending Others(?![\\p{L}\\p{N}_])" 




},
  { "text": "Upcoming", "mode": "label", "pattern": "^(?:Upcoming)$" 




},
  { "text": "Recent", "mode": "label", "pattern": "^(?:Recent)$" 




},
  { "text": "Needs attention", "mode": "label", "pattern": "^(?:Needs attention)$" 




},
  { "text": "Recruitment request", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Recruitment request(?![\\p{L}\\p{N}_])" 




},
  { "text": "Raise a request", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Raise a request(?![\\p{L}\\p{N}_])" 




},
  { "text": "Claim", "mode": "label", "pattern": "^(?:Claim)$" 




},
  { "text": "Post the position", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Post the position(?![\\p{L}\\p{N}_])" 




},
  { "text": "Checkpoints C1–C7", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Checkpoints C1–C7(?![\\p{L}\\p{N}_])" 




},
  { "text": "Onsite interviews", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Onsite interviews(?![\\p{L}\\p{N}_])" 




},
  { "text": "Time to fill", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Time to fill(?![\\p{L}\\p{N}_])" 




},
  { "text": "Phase targets", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Phase targets(?![\\p{L}\\p{N}_])" 




},
  { "text": "Trending behind", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Trending behind(?![\\p{L}\\p{N}_])" 




},
  { "text": "Past target", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Past target(?![\\p{L}\\p{N}_])" 




},
  { "text": "Behind", "mode": "label", "pattern": "^(?:Behind)$" 




},
  { "text": "letter grades A+…C", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])[lL]etter grades A\\+…C(?![\\p{L}\\p{N}_])" 




},
  { "text": "Pipeline Health", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Pipeline Health(?![\\p{L}\\p{N}_])" 




},
  { "text": "Summary Sheet", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Summary Sheet(?![\\p{L}\\p{N}_])" 




},
  { "text": "Compile summary", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Compile summary(?![\\p{L}\\p{N}_])" 




},
  { "text": "Debrief call", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Debrief call(?![\\p{L}\\p{N}_])" 




},
  { "text": "debrief cycle", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])[dD]ebrief cycle(?![\\p{L}\\p{N}_])" 




},
  { "text": "The two-2s rule", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])The two-2s rule(?![\\p{L}\\p{N}_])" 




},
  { "text": "Two ratings of 2 or below make this No Hire", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Two ratings of 2 or below make this No Hire(?![\\p{L}\\p{N}_])" 




},
  { "text": "Director & Sr Director", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Director & Sr Director(?![\\p{L}\\p{N}_])" 




},
  { "text": "VP & Above", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])VP & Above(?![\\p{L}\\p{N}_])" 




},
  { "text": "Panel interviews", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Panel interviews(?![\\p{L}\\p{N}_])" 




},
  { "text": "onsite loop", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])[oO]nsite loop(?![\\p{L}\\p{N}_])" 




},
  { "text": "Approve packets and send the kickoff", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Approve packets and send the kickoff(?![\\p{L}\\p{N}_])" 




},
  { "text": "Reschedule / Replace", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Reschedule / Replace(?![\\p{L}\\p{N}_])" 




},
  { "text": "Promote the backup", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Promote the backup(?![\\p{L}\\p{N}_])" 




},
  { "text": "Optional assessment", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Optional assessment(?![\\p{L}\\p{N}_])" 




},
  { "text": "exercise", "mode": "label", "pattern": "^(?:[eE]xercise)$" 




},
  { "text": "Reference election", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Reference election(?![\\p{L}\\p{N}_])" 




},
  { "text": "Comp package", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Comp package(?![\\p{L}\\p{N}_])" 




},
  { "text": "the mandate", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])[tT]he mandate(?![\\p{L}\\p{N}_])" 




},
  { "text": "Propose the package", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Propose the package(?![\\p{L}\\p{N}_])" 




},
  { "text": "Approve out-of-range", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Approve out-of-range(?![\\p{L}\\p{N}_])" 




},
  { "text": "Letter after verbal", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Letter after verbal(?![\\p{L}\\p{N}_])" 




},
  { "text": "Send batch n", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Send batch \\d+(?![\\p{L}\\p{N}_])" 




},
  { "text": "Receipt", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Receipt(?![\\p{L}\\p{N}_])" 




},
  { "text": "Saved · Receipt #n", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Saved · Receipt #\\d+(?![\\p{L}\\p{N}_])" 




},
  { "text": "View as", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])View as(?![\\p{L}\\p{N}_])" 




},
  { "text": "Talent Pools", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Talent Pools(?![\\p{L}\\p{N}_])" 




},
  { "text": "Match %", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Match %" 




},
  { "text": "Fit", "mode": "label", "pattern": "^(?:Fit)$" 




},
  { "text": "Match Intelligence", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Match Intelligence(?![\\p{L}\\p{N}_])" 




},
  { "text": "Interview Copilot", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Interview Copilot(?![\\p{L}\\p{N}_])" 




},
  { "text": "AI Copilot panel", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])AI Copilot panel(?![\\p{L}\\p{N}_])" 




},
  { "text": "Drafts", "mode": "label", "pattern": "^(?:Drafts)$" 




},
  { "text": "Dismiss", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Dismiss(?![\\p{L}\\p{N}_])" 




},
  { "text": "Build Panel", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Build Panel(?![\\p{L}\\p{N}_])" 




},
  { "text": "My Interviews", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])My Interviews(?![\\p{L}\\p{N}_])" 




},
  { "text": "Packets & Sheets", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Packets & Sheets(?![\\p{L}\\p{N}_])" 




},
  { "text": "My Packet", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])My Packet(?![\\p{L}\\p{N}_])" 




},
  { "text": "My Debriefs", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])My Debriefs(?![\\p{L}\\p{N}_])" 




},
  { "text": "Access request from <name>", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Access request from .+?" 




},
  { "text": "Closed at resume review", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Closed at resume review(?![\\p{L}\\p{N}_])" 




},
  { "text": "Not attended", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Not attended(?![\\p{L}\\p{N}_])" 




},
  { "text": "Your packet", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Your packet(?![\\p{L}\\p{N}_])" 




},
  { "text": "Values & Skills Assessed", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Values & Skills Assessed(?![\\p{L}\\p{N}_])" 




},
  { "text": "Assesses", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Assesses(?![\\p{L}\\p{N}_])" 




},
  { "text": "Target role", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Target role(?![\\p{L}\\p{N}_])" 




},
  { "text": "Format", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Format(?![\\p{L}\\p{N}_])" 




},
  { "text": "Duration", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Duration(?![\\p{L}\\p{N}_])" 




},
  { "text": "Guide", "mode": "label", "pattern": "^(?:Guide)$" 




},
  { "text": "Backup", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Backup(?![\\p{L}\\p{N}_])" 




},
  { "text": "Before you start", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Before you start(?![\\p{L}\\p{N}_])" 




},
  { "text": "Saving… · n items left", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Saving… · \\d+ items left(?![\\p{L}\\p{N}_])" 




},
  { "text": "Average of scored dimensions … a guide, not a rule", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Average of scored dimensions … a guide, not a rule(?![\\p{L}\\p{N}_])" 




},
  { "text": "4.0 – 5.0 Hire", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])4\\.0 – 5\\.0 Hire(?![\\p{L}\\p{N}_])" 




},
  { "text": "Still needed", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Still needed(?![\\p{L}\\p{N}_])" 




},
  { "text": "I confirm this scorecard…", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])I confirm this scorecard…" 




},
  { "text": "Your own result only…", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Your own result only…" 




},
  { "text": "Not assessed", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Not assessed(?![\\p{L}\\p{N}_])" 




},
  { "text": "Propose times", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Propose times(?![\\p{L}\\p{N}_])" 




},
  { "text": "Propose three times", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Propose three times(?![\\p{L}\\p{N}_])" 




},
  { "text": "Book", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Book(?![\\p{L}\\p{N}_])" 




},
  { "text": "Book all", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Book all(?![\\p{L}\\p{N}_])" 




},
  { "text": "Send reminder", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Send reminder(?![\\p{L}\\p{N}_])" 




},
  { "text": "Late by", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Late by(?![\\p{L}\\p{N}_])" 




},
  { "text": "organizer", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])[oO]rganizer(?![\\p{L}\\p{N}_])" 




},
  { "text": "With", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])With(?![\\p{L}\\p{N}_])" 




},
  { "text": "Where / link", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Where / link(?![\\p{L}\\p{N}_])" 




},
  { "text": "Copy itinerary", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Copy itinerary(?![\\p{L}\\p{N}_])" 




},
  { "text": "Skill #n", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Skill #\\d+(?![\\p{L}\\p{N}_])" 




},
  { "text": "Record verbal offer", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Record verbal offer(?![\\p{L}\\p{N}_])" 




},
  { "text": "Choose another", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Choose another(?![\\p{L}\\p{N}_])" 




},
  { "text": "Recruiter's read", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Recruiter's read(?![\\p{L}\\p{N}_])" 




},
  { "text": "Confirm", "mode": "label", "pattern": "^(?:Confirm)$" 




},
  { "text": "Last activity", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Last activity(?![\\p{L}\\p{N}_])" 




},
  { "text": "Discard", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Discard(?![\\p{L}\\p{N}_])" 




},
  { "text": "Download", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Download(?![\\p{L}\\p{N}_])" 




},
  { "text": "Reload", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Reload(?![\\p{L}\\p{N}_])" 




},
  { "text": "Properties", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Properties(?![\\p{L}\\p{N}_])" 




},
  { "text": "Bug", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Bug(?![\\p{L}\\p{N}_])" 




},
  { "text": "Advance to screen", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Advance to screen(?![\\p{L}\\p{N}_])" 




},
  { "text": "Advance to my interview", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Advance to my interview(?![\\p{L}\\p{N}_])" 




},
  { "text": "Send decisions", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Send decisions(?![\\p{L}\\p{N}_])" 




},
  { "text": "Résumé v1", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Résumé v1(?![\\p{L}\\p{N}_])" 




},
  { "text": "Answer within", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Answer within(?![\\p{L}\\p{N}_])" 




},
  { "text": "decide within N business days", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])[dD]ecide within \\d+ business days(?![\\p{L}\\p{N}_])" 




},
  { "text": "1 held · {HM} decides after the first screens", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])1 held · .+? decides after the first screens(?![\\p{L}\\p{N}_])" 




},
  { "text": "Nothing assigned here", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Nothing assigned here(?![\\p{L}\\p{N}_])" 




},
  { "text": "Surviving record", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Surviving record(?![\\p{L}\\p{N}_])" 




},
  { "text": "Your decision", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Your decision(?![\\p{L}\\p{N}_])" 




},
  { "text": "Who decides", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Who decides(?![\\p{L}\\p{N}_])" 




},
  { "text": "Former time", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Former time(?![\\p{L}\\p{N}_])" 




},
  { "text": "Reset to template", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Reset to template(?![\\p{L}\\p{N}_])" 




},
  { "text": "Onsite Round 1", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Onsite Round 1(?![\\p{L}\\p{N}_])" 




},
  { "text": "Scorecard due · 24 hours", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Scorecard due · 24 hours(?![\\p{L}\\p{N}_])" 




},
  { "text": "EM-21/22", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])EM-21/22(?![\\p{L}\\p{N}_])" 




},
  { "text": "Ask the Hiring Manager", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Ask the Hiring Manager(?![\\p{L}\\p{N}_])" 




},
  { "text": "Ask your Recruiter", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Ask your Recruiter(?![\\p{L}\\p{N}_])" 




},
  { "text": "Open packet", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Open packet(?![\\p{L}\\p{N}_])" 




},
  { "text": "The scale", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])The scale(?![\\p{L}\\p{N}_])" 




},
  { "text": "Revisit", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Revisit(?![\\p{L}\\p{N}_])" 




},
  { "text": "Your attendance", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Your attendance(?![\\p{L}\\p{N}_])" 




},
  { "text": "Your scorecard", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Your scorecard(?![\\p{L}\\p{N}_])" 




},
  { "text": "Save revision", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Save revision(?![\\p{L}\\p{N}_])" 




},
  { "text": "What the room covers", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])What the room covers(?![\\p{L}\\p{N}_])" 




},
  { "text": "Who is in the room", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Who is in the room(?![\\p{L}\\p{N}_])" 




},
  { "text": "Attend / I cannot attend", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Attend / I cannot attend(?![\\p{L}\\p{N}_])" 




},
  { "text": "GoTo Foods | SECTION · Page x of y", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])GoTo Foods \\| SECTION · Page x of y(?![\\p{L}\\p{N}_])" 




},
  { "text": "Pipeline Health Score", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Pipeline Health Score(?![\\p{L}\\p{N}_])" 




},
  { "text": "Your scorecard is Past Due — the debrief cannot finalize without it", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Your scorecard is Past Due — the debrief cannot finalize without it(?![\\p{L}\\p{N}_])" 




},
  { "text": "Your packet — {candidate}", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Your packet — .+?" 




},
  { "text": "ASSESSES", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])ASSESSES(?![\\p{L}\\p{N}_])" 




},
  { "text": "Values and skills assessed", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Values and skills assessed(?![\\p{L}\\p{N}_])" 




},
  { "text": "Target role · Format · Duration · Guide", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Target role · Format · Duration · Guide(?![\\p{L}\\p{N}_])" 




},
  { "text": "Submitted · 4.33 / 5 · Hire", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Submitted · 4\\.33 / 5 · Hire(?![\\p{L}\\p{N}_])" 




},
  { "text": "Still needed: …", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Still needed: …" 




},
  { "text": "I confirm this scorecard reflects my own assessment of my assigned areas", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])I confirm this scorecard reflects my own assessment of my assigned areas(?![\\p{L}\\p{N}_])" 




},
  { "text": "Your own result only — the other interviewers' scores stay sealed until the debrief reveals them", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Your own result only — the other interviewers' scores stay sealed until the debrief reveals them(?![\\p{L}\\p{N}_])" 




},
  { "text": "5 Exceptional · 4 Exceeds requirement", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])5 Exceptional · 4 Exceeds requirement(?![\\p{L}\\p{N}_])" 




},
  { "text": "Late by 3 hours", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Late by 3 hours(?![\\p{L}\\p{N}_])" 




},
  { "text": "Format · With · Where / link", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Format · With · Where / link(?![\\p{L}\\p{N}_])" 




},
  { "text": "Discard upload", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Discard upload(?![\\p{L}\\p{N}_])" 




},
  { "text": "Copilot", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Copilot(?![\\p{L}\\p{N}_])" 




},
  { "text": "AI Copilot", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])AI Copilot(?![\\p{L}\\p{N}_])" 




},
  { "text": "Recruiter Copilot", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Recruiter Copilot(?![\\p{L}\\p{N}_])" 




},
  { "text": "GPT", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])GPT(?![\\p{L}\\p{N}_])" 




},
  { "text": "OpenAI", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])OpenAI(?![\\p{L}\\p{N}_])" 




},
  { "text": "Claude", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Claude(?![\\p{L}\\p{N}_])" 




},
  { "text": "Anthropic", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Anthropic(?![\\p{L}\\p{N}_])" 




},
  { "text": "Gemini", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Gemini(?![\\p{L}\\p{N}_])" 




},
  { "text": "Azure OpenAI", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Azure OpenAI(?![\\p{L}\\p{N}_])" 




},
  { "text": "LLM", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])LLM(?![\\p{L}\\p{N}_])" 




},
  { "text": "Recruiter Achievements", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Recruiter Achievements(?![\\p{L}\\p{N}_])" 




},
  { "text": "Progress System", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Progress System(?![\\p{L}\\p{N}_])" 




},
  { "text": "GoTo Foods", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])GoTo Foods(?![\\p{L}\\p{N}_])" 




},
  { "text": "Go To Foods", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Go To Foods(?![\\p{L}\\p{N}_])" 




},
  { "text": "GOTO FOODS", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])GOTO FOODS(?![\\p{L}\\p{N}_])" 




},
  { "text": "Onsite Round n", "mode": "phrase", "pattern": "(?<![\\p{L}\\p{N}_])Onsite Round \\d+(?![\\p{L}\\p{N}_])" 




},
  { "text": "My …", "mode": "regex", "pattern": "^My\\s" 




},
  { "text": "A+ … C", "mode": "regex", "pattern": "^(?:A\\+|A-?|B[+-]?|C[+-]?)$" 




}
];
